export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.30fb3b609fd29da3af4208714a6b4895.css";